import { useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { Avatar, AvatarDialog, Box, Button, PasswordDialog } from '../../widgets'
import { DropDown, Text } from '../../forms'
import { SettingsForm } from '../'

export const Profile = ({ goBackToSettingsMenu }) => {
  const request = useRequest('tenant')
  const { user: { name, email, avatar, admin } } = useView('tenant')

  const [avatarDialogOpen, setAvatarDialogOpen] = useState(false)
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false)
  const [selectedAvatar, setSelectedAvatar] = useState(avatar)

  const saveProfile = ({ name, email, admin }) => request('userUpdated', { name, email, admin: admin === 'Admin', avatar: selectedAvatar })

  const avatarSelected = (avatar) => {
    setSelectedAvatar(avatar)
    setAvatarDialogOpen(false)
  }

  return <SettingsForm
    onSubmit={saveProfile}
    values={{ name, email, admin: admin ? 'Admin' : 'Team lead' }}
    title="Edit profile"
    backButtonMobileOnly
    onBackButtonClick={goBackToSettingsMenu}
  >
    <Box gap={16} alignItems="center" justifyContent="flex-start" fullWidth>
      <Avatar
        index={selectedAvatar}
        label={admin ? 'ADMIN' : 'TEAM LEAD'}
        labelColor="white"
        labelBackground={admin ? 'red' : 'blue'}
      />
      <Button className="small" onClick={() => setAvatarDialogOpen(true)}>
        Change avatar
      </Button>
    </Box>

    <Text title="Name" name="name" value={name} required dark/>
    <Text title="Email" name="email" type="email" value={email} required dark readOnly />

    <Box pt={16}>
      <Button className="small" onClick={() => setPasswordDialogOpen(true)}>
        Change password
      </Button>
    </Box>

    <DropDown
      fullWidth
      dark
      name="admin"
      title="Role"
      required
      options={[{ label: 'Team lead', value: 'Team lead' }].concat(admin ? [{ label: 'Admin', value: 'Admin' }] : []).reverse()}
    />

    <AvatarDialog
      value={selectedAvatar}
      open={avatarDialogOpen}
      onClose={avatarSelected}
    />
    <PasswordDialog
      open={passwordDialogOpen}
      onClose={() => setPasswordDialogOpen(false)}
    />
  </SettingsForm>
}